import http from "../../utils/http"
/**
 * 獲取店鋪基礎信息
 */
export function shopInfo(params) {
    return http({
        url: "/api/shop/info",
        data: params
    })
}
/**
 * 獲取店鋪是否被關註
 */
export function isFollow(params) {
    return http({
        url: "/api/shopmember/issubscribe",
        data: params
    })
}
/**
 * 取消關註
 */
export function unFollow(params) {
    return http({
        url: "/api/shopmember/delete",
        data: params,
        forceLogin: true
    })
}
/**
 * 店鋪關註
 */
export function follow(params) {
    return http({
        url: "/api/shopmember/add",
        data: params,
        forceLogin: true
    })
}
/**
 * 獲取店鋪分類樹結構
 */
export function tree(params) {
    return http({
        url: "/api/shopgoodscategory/tree",
        data: params
    })
}
